import React, { Component } from 'react';

// Import from Style
import {
  HeadingTwo,
  Text,
  Inset
} from '../../elements';

// Import from Style
import {
  Wrapper,
  Items,
  DoubleMargin,
  Blocker,
} from './style';

import EditorialListItem from '../EditorialListItem';

class EditorialList extends Component {


  render() {
    const { list } = this.props;

    return (
      <Wrapper>
        <Blocker>
          &nbsp;
        </Blocker>
        <Inset>
          <HeadingTwo>{list.heading}</HeadingTwo>
          <DoubleMargin>
            <Text
              dangerouslySetInnerHTML={{
                __html: list.intro
              }}
            />
          </DoubleMargin>
          <Items>
            {list.items.map((item, index) => <EditorialListItem key={index} item={item}/>)}
          </Items>
        </Inset>
      </Wrapper>
    );
  }
}

export default EditorialList;



// WEBPACK FOOTER //
// ./src/components/EditorialList/index.js